import '@mantine/core/styles.layer.css';
import '@mantine/dates/styles.layer.css';
import './index.css';

import App from './App';

import { nptlabsTheme } from './theme/nptlabsTheme';

import { MantineProvider } from '@mantine/core';

import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { applyAppEnvironmentBranding } from './utils/appEnvironment';
import { LanguageProvider } from './i18n/LanguageContext';

applyAppEnvironmentBranding();

createRoot(document.getElementById('root')!).render(
  <MantineProvider theme={nptlabsTheme}>
    <LanguageProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </LanguageProvider>
  </MantineProvider>
);
